import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class Projects extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleEditChange = this.handleEditChange.bind(this);
        this.save = this.save.bind(this);
        this.update = this.update.bind(this);
        this.getProjects = this.getProjects.bind(this);
        //this.setItem = this.setItem.bind(this);
        //this.setSMSNotifications = this.setSMSNotifications.bind(this);
        this.state = {
            project: {},
            projectsLength: 0,
            edit: {},
            projects: [],
            token: "",
            view: null
        };
    }

    componentWillMount() {
        let self = this;

        let token = self.props.csrf_token;

        self.setState({
            token: token
        });
    }

    componentDidMount() {
        let self = this;

        self.getProjects();

        self.setState({
            view: 2
        });
    }

    handleChange({target}) {
        let self = this;

        let project = self.state.project;
        project[target.id] = target.value;

        self.setState({
            project: project
        });
    }

    handleEditChange({target}) {
        let self = this;

        let edit = self.state.edit;
        edit[target.id] = target.value;

        self.setState({
            edit: edit
        });
    }

    getProjects() {
        let self = this;

        let clearProjects = [];

        self.setState({
            projects: clearProjects
        });

        axios.get('/api/projects/list')
            .then(response => {

                let projects = response.data;

                self.setState({
                    projects: projects,
                    projectsLength: projects.length
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al procesar tu solicitud.",
                    icon: "warning",
                });
            });
    }

    setItem(item) {
        let self = this;

        let aux = {};
        aux['id'] = item.id;
        aux['name'] = item.name;
        aux['description'] = item.description;
        aux['notes'] = item.notes;
        aux['status'] = parseInt(item.status);
        aux['sms_notifications'] = item.sms_notifications;
        aux['subdomain'] = item.subdomain;

        self.setState({
            edit: aux
        });

        $('#editProjectModal').modal('show');
    }

    setSMSNotifications(flag, type) {
        let self = this;

        if (type === 'new') {
            let project = self.state.project;
            project['sms_notifications'] = flag;

            self.setState({
                project: project
            });
        } else if (type === 'edit') {
            let edit = self.state.edit;
            edit['sms_notifications'] = flag;

            self.setState({
                edit: edit
            });
        }
    }

    setProjectStatus(flag) {
        let self = this;

        let edit = self.state.edit;
        edit['status'] = flag;

        self.setState({
            edit: edit
        });
    }

    save() {
        let self = this;


        if (!self.state.project.name || !self.state.project.name) {
            swal({
                title: "¡Oh no!",
                text: "Por favor, completa los campos antes de proceder.",
                icon: "warning",
            });
        } else {
            let request = self.state.project;

            swal({
                title: 'Un momento...',
                text: 'Estamos procesando tu solicitud.',
                buttons: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnClickOutside: false,
            });

            axios.post('/api/projects/register', request)
                .then(response => {

                    let project = response.data;

                    $("#projectSaveForm").attr("action", "/projects/image/" + project.id);
                    $("#projectSaveForm").submit();

                    $(':input', '#projectRegisterForm')
                        .not(':button, :submit, :reset, :hidden')
                        .val('')
                        .removeAttr('checked')
                        .removeAttr('selected');

                    self.getProjects();

                })
                .catch(error => {
                    let rs = error.response.data;

                    switch (rs) {
                        case 'registered':
                            swal({
                                title: "¡Oh no!",
                                text: "El subdominio ya se encuentra registrado.",
                                icon: "warning",
                            });
                            break;
                        default:
                            swal({
                                title: "¡Oh no!",
                                text: "Ha ocurrido un error al procesar tu solicitud.",
                                icon: "warning",
                            });
                            break;
                    }
                });
        }
    }

    update() {
        let self = this;

        if (!self.state.edit.name || !self.state.edit.description) {
            swal({
                title: "¡Oh no!",
                text: "Por favor, completa los campos antes de proceder.",
                icon: "warning",
            });
        } else {
            let request = self.state.edit;

            swal({
                title: 'Un momento...',
                text: 'Estamos procesando tu solicitud.',
                buttons: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnClickOutside: false,
            });

            axios.post('/api/projects/update', request)
                .then(response => {


                    $('#editProjectModal').modal('hide');

                    let project = response.data;

                    $("#imgUpdateForm").attr("action", "/projects/image/" + project.id);
                    $("#imgUpdateForm").submit();

                    $(':input', '#projectEditForm')
                        .not(':button, :submit, :reset, :hidden')
                        .val('')
                        .removeAttr('checked')
                        .removeAttr('selected');

                })
                .catch(error => {
                    let rs = error.response.data;

                    console.log(rs);

                    switch (rs) {
                        case 'more_active_projects':
                            swal({
                                title: "¡Oh no!",
                                text: "No puedes tener más de un proyecto activo.",
                                icon: "warning",
                            });
                            break;
                        default:
                            swal({
                                title: "¡Oh no!",
                                text: "Ha ocurrido un error al procesar tu solicitud.",
                                icon: "warning",
                            });
                            break;
                    }
                });
        }
    }

    deleteItem(id) {
        let self = this;

        axios.get('/api/projects/delete/' + id)
            .then(response => {
                self.getProjects();
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al procesar tu solicitud.",
                    icon: "warning",
                });
            });
    }

    setView(view) {
        let self = this;
        let project = {};

        self.setState({
            view: view,
            project: project
        });
    }

    renderItem(item) {
        let self = this;
        let prLength = self.state.projectsLength;

        let itemUrl = "" + item.subdomain_url;

        return (
            <tr key={item.id}>
                <td>
                    <img src={item.image_url} style={{height: "50px"}} className="img-responsive"/>
                </td>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>
                    {
                        parseInt(item.status) === 1 &&
                        <button className="btn btn-success">
                            ACTIVO
                        </button>
                    }
                    {
                        parseInt(item.status) !== 1 &&
                        <button className="btn btn-danger">
                            INACTIVO
                        </button>
                    }
                </td>
                <td>
                    <button className="btn btn-purple btn-block" onClick={this.openSubdomainTab.bind(this, item)}>
                        <i className="fa fa-globe"></i> <strong>{itemUrl}</strong>
                    </button>
                </td>
                <td>{item.notes}</td>
                <td>{item.created_at}</td>
                <td>
                    {
                        prLength !== 0 &&
                        <div>
                            <button className={"btn btn-warning waves-effect waves-light"}
                                    onClick={this.deleteItem.bind(this, item.id)}>
                                <i className="fa fa-times"></i>
                            </button>
                            &nbsp;
                            <button className={"btn btn-info waves-effect waves-light"}
                                    onClick={this.setItem.bind(this, item)}>
                                <i className="fa fa-pencil"></i>
                            </button>
                        </div>
                    }
                </td>
            </tr>
        );
    }

    openSubdomainTab(item) {
        let url = "http://" + item.subdomain_url;
        let win = window.open(url, '_blank');
        win.focus();
    }

    render() {
        let self = this;

        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-4 col-md-offset-4"
                                             style={{paddingTop: "25px", paddingBottom: "25px"}}>
                                            <div className="col-md-8 col-md-offset-2">
                                                <img src="img/projects.png" className="img-responsive"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-body"}>
                                    <label>
                                        Acciones
                                    </label>
                                    <hr/>

                                    <div className="col-md-3">
                                        <button type="button"
                                                className={"btn btn-block " + (this.state.view === null ? 'btn-white' : (parseInt(this.state.view) === 1 ? 'btn-info' : 'btn-white'))}
                                                onClick={this.setView.bind(this, 1)}>
                                            <i className="fa fa-plus"></i> Nuevo proyecto
                                        </button>
                                    </div>

                                    <div className="col-md-3">
                                        <button type="button"
                                                className={"btn btn-block " + (this.state.view === null ? 'btn-white' : (parseInt(this.state.view) === 2 ? 'btn-success' : 'btn-white'))}
                                                onClick={this.setView.bind(this, 2)}>
                                            <i className="fa fa-eye"></i> Ver proyectos
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        parseInt(this.state.view) === 1 &&
                        <div className="row">
                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className={"panel-body"}>
                                        <h4 className="m-t-0 header-title"><b>Registrar Proyecto</b></h4>
                                        <form role="form" id="projectRegisterForm">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Nombre</label>
                                                            <input typeof="text" className="form-control" id="name"
                                                                   onChange={this.handleChange}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Subdominio</label>
                                                            <input typeof="text" className="form-control" id="subdomain"
                                                                   onChange={this.handleChange}/>
                                                            {
                                                                (typeof this.state.project.subdomain !== 'undefined' && this.state.project.subdomain.length !== 0) &&
                                                                <small>URL: {this.state.project.subdomain}.tucuponfacil.com</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Email</label>
                                                            <input typeof="text" className="form-control"
                                                                   id="email_notification"
                                                                   onChange={this.handleChange}/>
                                                            <small>Te notificaremos cuando el subdominio esté listo.
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="description">Descripción</label>
                                                            <input typeof="text" className="form-control"
                                                                   id="description"
                                                                   onChange={this.handleChange}/>
                                                        </div>
                                                    </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="notes">Notas *</label>
                                                                <textarea typeof="number" className="form-control"
                                                                          id="notes"
                                                                          onChange={this.handleChange}/>
                                                                <small>* - Campo NO obligatorio</small>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Status</label>
                                                                <div className="col-md-12">
                                                                    <div className="col-md-6">
                                                                        <button type="button"
                                                                                className={"btn btn-block " + (self.state.edit.status === 1 ? 'btn-success' : 'btn-white')}
                                                                                onClick={this.setProjectStatus.bind(this, 1)}>
                                                                            <i className="fa fa-check"></i> Activo
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <button type="button"
                                                                                className={"btn btn-block " + (self.state.edit.status === 0 ? 'btn-danger' : 'btn-white')}
                                                                                onClick={this.setProjectStatus.bind(this, 0)}>
                                                                            <i className="fa fa-times"></i> Inactivo
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Notificaciones a los clientes por SMS</label>
                                                            <div className="col-md-12">
                                                                <div className="col-md-6">
                                                                    <button type="button"
                                                                            className={"btn btn-block " + (parseInt(self.state.edit.sms_notifications) === 1 ? 'btn-success' : 'btn-white')}
                                                                            onClick={this.setSMSNotifications.bind(this, 1, 'edit')}>
                                                                        <i className="fa fa-check"></i> SI
                                                                    </button>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <button type="button"
                                                                            className={"btn btn-block " + (parseInt(self.state.edit.sms_notifications) === 0 ? 'btn-danger' : 'btn-white')}
                                                                            onClick={this.setSMSNotifications.bind(this, 0, 'edit')}>
                                                                        <i className="fa fa-times"></i> NO
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                        <br/>

                                        <div className="col-md-12">
                                            <form id="projectSaveForm" method="post" encType="multipart/form-data">
                                                <input type="hidden" id="_token" name="_token" value={this.state.token}
                                                       onChange={this.handleChange}/>
                                                <div className="form-group">
                                                    <label htmlFor="projectImg">Imagen para el projecto</label>
                                                    <input type="file" className="form-control" id="projectImg"
                                                           name="projectImg"/>
                                                </div>
                                            </form>
                                        </div>

                                        <br/>

                                        <small>* - Campo NO obligatorio</small>

                                        <button type="button"
                                                className="btn btn-purple waves-effect waves-light pull-right"
                                                id="promosRegisterButton" onClick={this.save}
                                                disabled={!self.state.project.name || !self.state.project.description
                                                || !self.state.project.subdomain || !self.state.project.email_notification}>
                                            <i className="fa fa-save"></i> Guardar
                                        </button>

                                    </div>
                                </div>
                            </div>

                        </div>
                    }

                    {
                        parseInt(this.state.view) === 2 &&

                        <div className="row">
                            <div id="editProjectModal" className="modal fade" tabIndex="-1" role="dialog"
                                 aria-labelledby="myModalLabel" aria-hidden="true" style={{display: "none"}}>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <button type="button" className="close" data-dismiss="modal"
                                                    aria-hidden="true">×
                                            </button>
                                            <h4 className="modal-title" id="myModalLabel">Editar Proyecto</h4>
                                        </div>
                                        <div className="modal-body">
                                            <form role="form" id="projectEditForm">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Nombre</label>
                                                            <input typeof="text" className="form-control" id="name"
                                                                   value={this.state.edit.name}
                                                                   onChange={this.handleEditChange}/>
                                                        </div>

                                                        <div className="form-group">
                                                            <label htmlFor="description">Descripción</label>
                                                            <input typeof="text" className="form-control"
                                                                   id="description"
                                                                   value={this.state.edit.description}
                                                                   onChange={this.handleEditChange}/>
                                                        </div>

                                                        <div className="form-group">
                                                            <label htmlFor="notes">Notas *</label>
                                                            <textarea typeof="number" className="form-control"
                                                                      id="notes"
                                                                      value={this.state.edit.notes}
                                                                      onChange={this.handleEditChange}/>
                                                        </div>

                                                        <small>* - Campo NO obligatorio</small>
                                                    </div>
                                                </div>
                                            </form>

                                            <form id="imgUpdateForm" method="post" encType="multipart/form-data">
                                                <input type="hidden" id="_token" name="_token" value={this.state.token}
                                                       onChange={this.handleChange}/>
                                                <div className="form-group">
                                                    <label htmlFor="projectImg">Imagen para el projecto</label>
                                                    <input type="file" className="form-control" id="projectImgUpdate"
                                                           name="projectImgUpdate"/>
                                                </div>
                                            </form>

                                            <button type="button"
                                                    className="btn btn-purple waves-effect waves-light pull-right"
                                                    id="promosRegisterButton" onClick={this.update}
                                                    disabled={!self.state.edit.name || !self.state.edit.description}>
                                                <i className="fa fa-save"></i> Guardar
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className={"panel-body"}>
                                        <h4 className="m-t-0 header-title"><b>Proyectos</b></h4>
                                        {
                                            this.state.projects.length !== 0 &&
                                            <div className="row">
                                                <div className="col-md-12 p-20">
                                                    <table className="table table-striped m-0">
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Nombre</th>
                                                            <th>Descripción</th>
                                                            <th>Status</th>
                                                            <th>URL</th>
                                                            <th>Notas</th>
                                                            <th>Fecha de registro</th>
                                                            <th></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.projects.map(this.renderItem.bind(this))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Projects;

if (document.getElementById('projects-component')) {
    ReactDOM.render(<Projects csrf_token={csrf_token}/>, document.getElementById('projects-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/Projects.jsx